import React, {useState} from 'react';
import '../../Default.css';
import SongType from './songsType'
import './Songs.css';
import Dropdown from '../../components_ui/dropdown/Dropdown';

import song_file from "./songs.json"
const songs: SongType[] = song_file as any;

const Song = ({song={title: "", lyrics: [{rows: [""], type: "chorus"}]} as SongType}) => {
  let verse = 0;
  return (
    <>
        <div className='text-box-header'>{song.title}</div>
        {song.lyrics.map((elem, index) => {
          if (elem.type === "chorus") return <div className='song-chorus'>
              {elem.rows.map((row, index) => <p>
                {index === 0 ? "Ref. " : ""}{row}
              </p>)}
            </div>
          else if (elem.type === "bridge") return <div className='song-bridge'>
            {elem.rows.map((row, index) => <p>
              {index === 0 ? "Brigdge " : ""}{row}
            </p>)}
          </div>
          else {
            verse += 1;
            return <div className='song-verse'>
              {elem.rows.map((row, id) => 
                <p>{id === 0 ? verse+"." : ""} {row}</p>)}
              </div>
          }
        })}
    </>
  )
};


function Hymn() {
  const [language, setLanguage] = useState("polish");

  const setPolish = () => {
    setLanguage("polish");
  };
  
  const setPortuguese = () => {
    setLanguage("portuguese");
  };
  
  return (
    <>
      <div className="page-title">
        Hymn
      </div>
      <div className='boxes-contener'>
        <div className='copyright-tekst'>
          {songs.map(elem => {
            if(elem.language === language) return <>{elem.author}</>
            else return <></>
          })}
        </div>
        <Dropdown>
          <b>wybierz język</b>
          <div onClick={setPolish}>polski</div>
          <div onClick={setPortuguese}>portugalski</div>
        </Dropdown>
        <div>
          {songs.map(elem => {
            if(elem.language === language) return <Song song={elem}/>
            else return <></>
          })}
        </div>
      </div>
    </>
  );
}

export default Hymn;
